// PatientInfo token -> PatientDataBE property name (only differing names).
export const PATIENT_DATA_PROPERTY_BY_TOKEN = { Telephone: 'TelephoneNumber' };

// DateOfBirth is parsed with DateTime.TryParse and stored in ISO "s" format by the backend,
// so send it as ISO (no timezone shift) regardless of the display format.
export function toIsoDateString(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00`;
}

export function buildPatientDataJson(subFieldEntries) {
  const patientData = {};

  subFieldEntries.forEach(({ inputs }) => {
    const input = inputs[0];
    const token = input?.dataset?.token;
    if (!token) return;

    let value = '';
    if (input.Datepicker) {
      const selectedDate = input.Datepicker.instance.getDate();
      value = selectedDate ? toIsoDateString(selectedDate) : '';
    } else {
      value = (input.value || '').trim();
    }

    patientData[PATIENT_DATA_PROPERTY_BY_TOKEN[token] || token] = value;
  });

  return JSON.stringify(patientData);
}
